import api from './api';
import types from './mutation-types';

export default {
	defaultAssign_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, {
			key,
			value
		});
	},

	getPlant_({ commit }) {
		return api
			.getPlant()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_OPTION_PLANT_LIST, {
						key: 'plants',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getScreens_({ commit }, params = { plantCd }) {
		return api
			.getScreens(params)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_SCREEN_LIST, {
						key: 'controlScrIds',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getControlList_({ commit }, params = { plantCd, scrId, scrName, userId, onlyIng, currentPage, pageUnit }) {
		return api
			.getControlList(params)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_SEARCH_PARAM, params);
					const { currentPage, pageUnit, totalSize } = data.body.pagingInfo;
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: { currentPage, pageUnit, totalSize, data: data.body.resultList }
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	postControl_({ commit }, params = { plantCd, controlList }) {
		return api
			.postControl(params, params.controlList)
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					// throw new Error(data.header.message);
					throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	}
};
